import {
  EAuditResultType,
} from '@/types/audit-result.ts';
import {
  TComponentValue,
} from '@/types/openapi-type.ts';

const sectionResult: Record<TComponentValue<'AuditResultType'>, string> = {
  [EAuditResultType.PASSED]: 'V pásme',
  [EAuditResultType.INCONCLUSIVE]: 'Nerozhodný',
  [EAuditResultType.FAILED]: 'Mimo pásma',
};

export default {
  timeIn: 'Čas vstúpenia',
  timeOut: 'Čas výstupu',
  valueAtStart: 'Hodnota na začiatku',
  valueRange: 'Rozsah hodnôt',
  mainTemp: 'Hlavná teplota',
  medianValue: 'Stredná hodnota',
  timeInBand: 'Čas v pásme',
  sectionResult,
};
